let pendingRequests = 0;

export function showSpinner() {
  pendingRequests++;
  $('#spinner').stop(true, true).show();
}

export function hideSpinner() {
  pendingRequests = Math.max(0, pendingRequests - 1);
  if (pendingRequests === 0) {
    $('#spinner').fadeOut();
  }
}

// The Stimulus controllers (separate bundle) and other page scripts call these
// as globals, as they did when Sprockets concatenated everything.
window.showSpinner = showSpinner;
window.hideSpinner = hideSpinner;

$(function() {
  $('body').append('<div id="spinner"></div>');
  $('#spinner').hide();

  $(document).on('ajax:beforeSend', '[data-remote]', function(e, xhr) {
    e.stopPropagation();
    showSpinner();

    // Bind completion to the XHR itself instead of the DOM element, so the
    // spinner still hides if the originating element is removed from the DOM
    // before the response arrives.
    xhr.always(hideSpinner);
  });
});
